export enum EnumCouponType{
    OneTimeForAll = '1time4all',
    OneTimeForUser = '1time4user',
    Simple = 'simple',
    OnlyForUsers = 'only-for-users'
}
